import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "name-constrain",
  class: "label-text required"
}, "Nama Kendala", -1)
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "label-text required"
}, "Keterangan", -1)
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_9 = { class: "container-btn-action" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Simpan")

import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import { Form, Field, FieldArray, ErrorMessage } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import Checkbox from 'primevue/checkbox'
import { onMounted, getCurrentInstance, ref, reactive } from 'vue'
import { IBankForm } from '@/utils/interfaces/iBank'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull } from 'lodash'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const store = useStore()
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const dataForm = ref()
const titleButton = ref('Simpan Jenis Kendala')
const isUpdate = ref(false)

const moduleStore = 'hjpDataList'
const endpoint = '/management/v1/MsConstraint'

const initialValues = {
  Name: store.state[moduleStore].modalForm.data ? store.state[moduleStore].modalForm.data.Name : '',
  IsActive: store.state[moduleStore].modalForm.data ? store.state[moduleStore].modalForm.data.IsActive : true,
  Description: store.state[moduleStore].modalForm.data ? store.state[moduleStore].modalForm.data.Description : ''
  // password: ''
}

const schema = Yup.object().shape({
  Name: Yup.string().required('Nama Kendala harus diisi!')
    .max(30, 'Nama Kendala maksimal 30 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Jenis Pengeluaran tidak valid!')
    .test('unique-name', 'Nama Kendala sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['name']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name === val)
        if (store.state[moduleStore].modalForm.data) {
          return filterResult.length === 0 || val === initialValues.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Description: Yup.string().required('Keterangan harus diisi!')
})

const attrModalConfirmation = reactive({
  show: false,
  title: '',
  subTitle: '',
  btnSubmitTitle: '',
  imgContent: require('@/assets/img/modal-confirmation/passenger-add-update.svg')
})

const checkAddOrUpdate = () => {
  if (store.state[moduleStore].modalForm.data) {
    attrModalConfirmation.title = 'Simpan Perubahan Jenis Kendala?'
    attrModalConfirmation.subTitle = 'Pastikan data data Jenis Kendala sudah benar dan sesuai dengan yang Anda inginkan.'
    attrModalConfirmation.btnSubmitTitle = titleButton.value
    isUpdate.value = true
  } else {
    attrModalConfirmation.title = 'Simpan Jenis Kendala '
    attrModalConfirmation.subTitle = 'Pastikan data data Jenis Kendala sudah benar dan sesuai dengan yang Anda inginkan.'
    attrModalConfirmation.btnSubmitTitle = titleButton.value
  }
}

const onSubmit = (val: any) => {
  dataForm.value = {
    Name: val.Name,
    IsActive: val.IsActive,
    Description: val.Description
  }
  attrModalConfirmation.show = true
}

const hideSidebar = () => {
  store.dispatch('setShowModalFormDl', false)
}

const onSubmitConfirmation = async () => {
  const toastMessage = isUpdate.value ? 'Berhasil mengubah Jenis Kendala' : 'Berhasil menambahkan Jenis Kendala'
  const toastDetailMesssage = isUpdate.value ? 'Jenis Kendala sudah diubah dan dapat digunakan pada fitur lain.' : 'Jenis Kendala sudah ditambahkan dan dapat digunakan pada fitur lain.'
  const response = !isUpdate.value ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, store.state[moduleStore].modalForm.data.Id, dataForm.value)
  if (!response.error) {
    store.dispatch('setShowModal', false)
    store.dispatch('setReloadDataTable', true)
    $toast.add({
      severity: 'success',
      summary: toastMessage,
      detail: toastDetailMesssage,
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    // store.dispatch('setShowModal', false)
    $toast.add({
      severity: 'error',
      detail: response.message,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  // eslint-disable-next-line no-use-before-define
  hideDialogConfirmation()
  hideSidebar()
}

const hideDialogConfirmation = () => {
  attrModalConfirmation.show = false
}

onMounted(() => {
  let titleForm = 'Tambah'
  if (store.state[moduleStore].modalForm.data) {
    titleForm = 'Edit'
    titleButton.value = 'Simpan perubahan'
  }
  checkAddOrUpdate()
  store.dispatch('setTitleFormSidebar', `${titleForm} Jenis Kendala`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_unref(Field), { name: "Name" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps({ id: "name-constrain" }, field, {
                modelValue: values.Name,
                "onUpdate:modelValue": ($event: any) => ((values.Name) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                placeholder: "Tulis nama kendala",
                maxlength: 30,
                autocomplete: "off"
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_3, _toDisplayString(errors.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(Field), {
            id: "description",
            name: "Description",
            as: "textarea",
            placeholder: "Tulis Keterangan",
            class: "input-primary"
          }),
          _createElementVNode("div", _hoisted_6, _toDisplayString(errors.Description), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_unref(Field), { name: "IsActive" }, {
            default: _withCtx(({ field }) => [
              _createVNode(_unref(InputSwitch), _mergeProps({ class: "input-success" }, field, {
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                inputId: "isactive"
              }), null, 16, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(HjpCofirmModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle"])
  ]))
}
}

})